export const units = {
    entities: {
        "EUR-PL-QUARTER": {
            value: 20,
            label: "1/4 EUR-palle",
        },
        "EUR-PL-HALF": {
            value: 40,
            label: "1/2 EUR-palle",
        },
        "EUR-PL": {
            value: 80,
            label: "EUR-palle",
        },
        "UK-PL": {
            value: 100,
            label: "UK-palle",
        },
        FTL: {
            value: 2720,
            label: "FTL",
        },
        UNIT: {
            value: 0,
            label: "Enhed",
        },
        "BB-LG": {
            value: 0,
            label: "BB Large",
        },
        "BB-XL": {
            value: 0,
            label: "BB XL",
        },
        OTHER: {
            value: 0,
            label: "Andet",
        },
    },
};
const unitIds = [
    "EUR-PL-QUARTER",
    "EUR-PL-HALF",
    "EUR-PL",
    "UK-PL",
    "FTL",
    "UNIT",
    "BB-LG",
    "BB-XL",
    "OTHER",
];
export const getUnits = () => unitIds.map((id) => ({ id, ...units.entities[id] }));
export const getUnit = (key) => {
    return units.entities[key];
};
//# sourceMappingURL=units.js.map